const LogoutIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15 17V18.5C15 19.0523 14.5523 19.5 14 19.5H5C4.44771 19.5 4 19.0523 4 18.5V5.5C4 4.94772 4.44772 4.5 5 4.5H14C14.5523 4.5 15 4.94772 15 5.5V7"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.5 12L21 12L18 9"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M21 12L18 15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default LogoutIcon
